import { useQuery } from '@tanstack/react-query';
import { http } from '@lib/api';
import { queryKeys } from '@lib/queryKeys';
import type { DeliveryFlowWire } from '../board/boardWire';

/**
 * The tenant delivery flow (#2450): board columns, board range and rest days.
 * Under the `['dispatch', …]` root so a dispatch run or a settings save
 * refreshes it with everything else.
 */
export function useDeliveryFlow() {
  return useQuery({
    queryKey: queryKeys.dispatch.flow(),
    queryFn: () => http.get<DeliveryFlowWire>('/api/delivery-flow'),
    staleTime: 5 * 60_000,
    // A failed read must degrade to the default range and columns now, not after retries.
    retry: false,
  });
}
